import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { filter, throttleTime } from 'rxjs/operators';

interface BroadcastParams {
    for: string,
    payload: any
}

interface ListenInterface {
    debounce: number
}

// const genericSubject: BehaviorSubject<{}> = new BehaviorSubject({});

@Injectable()
export class SubjectService {

    genericSubject: BehaviorSubject<{}> = new BehaviorSubject({});

    broadcast(params: BroadcastParams) {
        this.genericSubject.next({
            for: params['for'] || '',
            payload: params['payload'] || {}
        })
    }

    listen(params: ListenInterface = { debounce: 500 }) {
        return this.genericSubject;
        // .pipe(
        //     // filter((value:any) => !!value && value.length >= 3),
        //     throttleTime(500)
        // );
    }
}